export let data = {
  title: "Rekam Medis Pasien",
  backBtn: "",
  actionBtn: [
    {
      class: "btn-primary  btn-with-icon-left",
      label: "Pasien Baru",
      link: "/pasien/form",
      iconLeft: "add"
    }
  ],
  breadcrumb: []
};
export let tabs = [
  { title: "SEMUA", filter: "", active: true },
  { title: "UMUM", filter: 1 },
  { title: "BPJS", filter: 2},
  { title: "ASURANSI LAIN", filter:3}
];
export let sorts = [
  {
    value: "desc",
    label: "Terbaru"
  },
  {
    value: "asc",
    label: "Terlama"
  }
];
export let filters = {
  colnum: "",
  columns: [
    {
      label: "Dari tanggal",
      type: "date",
      placeholder: "Tanggal daftar",
      name: "created_from",
      value: "",
      mandatory: true,
      colwidth: 3,
      id: "filterDateStart"
    },
    {
      label: "sampai tanggal",
      type: "date",
      placeholder: "Tanggal daftar",
      name: "created_to",
      value: "",
      mandatory: true,
      colwidth: 3,
      id: "filterDateEnd"
    },
  ]
};
export let sort = {
  colnum: 1,
  columns: [
    {
      label: "Sort By",
      type: "select",
      name:"orderBy",
      placeholder: "",
      value: "desc",
      mandatory: true,
      options: sorts
    }
  ]
};
